'use strict';

module.exports = lineBreak;
var backslash = '\\';
var lineFeed = '\n';
var space = ' ';
var commonmark = backslash + lineFeed;
var normal = space + space + lineFeed;

function lineBreak() {
  return this.options.commonmark ? commonmark : normal;
}